import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { change } from 'redux-form';
import moment from 'moment';
import _ from 'lodash';

import { Filter, Main } from 'Containers/';
import {
  DAILY_DEPOSIT_FORM_NAME,
  DAILY_DEPOSIT_FILTERS_FORM_NAME,
} from 'Common/FormEnum';
import { LoadingPage, TitledCard } from 'Components/';
import { DailyDepositFieldEnum as Fields } from 'Common/FieldEnum';
import { defaultDateFormat } from 'Common/GeneralHelper';
import {
  createToast,
  toastType,
  errorToast,
  successToast,
} from 'Common/ToastHelper';
import { formatDecimal } from 'Common/FormHelper';
import { ReportGeneration } from 'Common/ObjectHelper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { DirtyWrapper } from 'Components/tracked/DirtyWrapper';

import * as DailyDepositActions from './state/dailydeposit/actions';
import * as DailyDepositSelectors from './state/dailydeposit/selectors';
import { DailyDepositForm } from './components/DailyDepositForm';
import { DailyDepositFilters } from './components/DailyDepositFilters';
import { SiteFieldEnum, SubmitActionEnum } from './helpers/DailyDepositHelpers';

class DailyDepositContainer extends Component {
  state = {
    showWarningModal: false,
    warningModalWarnings: null,
    warningModalErrors: null,
    submitAction: null,
  };

  getMainProps = () => {
    const { formValues, isReadOnly, writeSave, filterValues } = this.props;
    return {
      toolbox: {
        formName: DAILY_DEPOSIT_FORM_NAME,
        shown: true,
        isReadOnly: isReadOnly,
        saveButtonProps: {
          content: 'Save & Close Day',
          disabled: this.shouldDisableEditing(),
          confirmText: 'Are you sure you want to close the day?',
        },
        rightButtons: [
          {
            content: 'Save',
            onClick: () => writeSave({ ...filterValues, ...formValues }),
            disabled:
              !filterValues ||
              !filterValues[Fields.Site] ||
              this.shouldDisableEditing(),
          },
          {
            content: 'View Daily Deposit',
            onClick: this.handleSubmit(SubmitActionEnum.ViewDailyDeposit),
            disabled: !filterValues || !filterValues[Fields.Site],
          },
          {
            content: 'View Bank Deposit',
            onClick: this.handleSubmit(SubmitActionEnum.ViewBankDeposit),
            disabled: !formValues || !formValues[Fields.IsClosed],
          },
        ],
      },
    };
  };

  shouldDisableEditing = () => {
    const { formValues, filterValues, isReadOnly } = this.props;
    return (
      !filterValues ||
      !filterValues[Fields.Site] ||
      isReadOnly ||
      !formValues ||
      formValues[Fields.IsClosed]
    );
  };

  componentDidMount() {
    this.props.getPrimarySites();
  }

  componentDidUpdate(prevProps) {
    const {
      clearError,
      primarySites,
      change,
      warnings,
      CEPErrors,
      report,
      setCloseSuccessful,
      setSaveSuccessful,
      getDailyDepositData,
      filterValues,
      clearReport,
    } = this.props;

    const { filterValues: prevFilterValues } = prevProps;

    errorToast(this.props, prevProps, 'fetchError', clearError);

    successToast(
      this.props,
      prevProps,
      'closeSuccessful',
      'Closed Successfully',
      () => setCloseSuccessful(false)
    );

    successToast(
      this.props,
      prevProps,
      'saveSuccessful',
      'Saved Successfully.',
      () => setSaveSuccessful(false)
    );

    if (prevProps.report !== report && report) {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'Case Type Report');
      }
      clearReport();
    }

    if (
      moment(filterValues[Fields.Date], DATE_FORMAT_FOR_UI, true).isValid() &&
      !_.isEqual(prevFilterValues, filterValues)
    ) {
      getDailyDepositData(
        filterValues[Fields.Site],
        filterValues[Fields.Date],
        filterValues[Fields.IsSupper]
      );
    }

    if (
      (warnings !== prevProps.warnings && warnings !== null) ||
      (CEPErrors !== prevProps.CEPErrors && CEPErrors !== null)
    ) {
      this.showWarnings(warnings, CEPErrors);
    }

    if (
      prevProps.primarySites.length === 0 &&
      primarySites &&
      primarySites.length === 1
    ) {
      change(DAILY_DEPOSIT_FILTERS_FORM_NAME, Fields.Site, primarySites[0].Id);
    }
  }

  showWarnings = (warnings, errors) => {
    if (
      ((warnings && warnings.length !== 0) ||
        (errors && errors.length !== 0)) &&
      !this.props.formValues[Fields.IsClosed]
    ) {
      this.setState({
        showWarningModal: true,
        warningModalWarnings: warnings.length ? warnings : null,
        warningModalErrors: errors.length ? errors : null,
      });
    } else {
      this.doSubmitAction(this.state.submitAction);
    }
  };

  confirmWarnings = () => {
    this.closeWarnings();
    this.doSubmitAction(this.state.submitAction);
  };

  closeWarnings = () => {
    this.setState({
      showWarningModal: false,
      warningModalWarnings: null,
      warningModalErrors: null,
    });
    this.props.clearWarnings();
  };

  handleSubmit = action => () => {
    const { filterValues, getWarnings } = this.props;
    this.setState({ submitAction: action });

    getWarnings(
      filterValues[Fields.Site],
      filterValues[Fields.Date],
      filterValues[Fields.IsSupper]
    );
  };

  doSubmitAction = action => {
    const {
      getDailyDepositReport,
      getBankDepositReport,
      writeCloseDay,
      formValues,
      clearWarnings,
      writeSave,
      filterValues,
    } = this.props;

    clearWarnings();

    const values = {
      ...filterValues,
      ...formValues,
    };

    switch (action) {
      case SubmitActionEnum.Save:
        writeSave(values);
        break;
      case SubmitActionEnum.ViewDailyDeposit:
        getDailyDepositReport(values);
        break;
      case SubmitActionEnum.ViewBankDeposit:
        getBankDepositReport(
          filterValues[Fields.Site],
          filterValues[Fields.Date],
          filterValues[Fields.IsSupper]
        );
        break;
      case SubmitActionEnum.CloseDay:
        writeCloseDay(values);
        break;
      default:
    }
    this.setState({ submitAction: null });
  };

  onAttendanceBlur = (isAttendanceFactor, index) => (e, value) => {
    const { formValues } = this.props;

    if (isAttendanceFactor) {
      this.updateAttendance(
        Math.round(
          formValues[Fields.Sites][index][SiteFieldEnum.Membership] *
            (value / 100)
        ),
        value / 100,
        index
      );
    } else {
      this.updateAttendance(
        value,
        parseFloat(value) /
          parseFloat(formValues[Fields.Sites][index][SiteFieldEnum.Membership]),
        index
      );
    }
  };

  updateAttendance = (attendance, attendanceFactor, index) => {
    const { formValues, change } = this.props;
    const site = formValues[Fields.Sites][index];
    const fieldPrefix = `${Fields.Sites}[${index}].`;
    change(
      DAILY_DEPOSIT_FORM_NAME,
      `${fieldPrefix}${SiteFieldEnum.AllowedFree}`,
      Math.round(parseFloat(site[SiteFieldEnum.MaxFree]) * attendanceFactor)
    );
    change(
      DAILY_DEPOSIT_FORM_NAME,
      `${fieldPrefix}${SiteFieldEnum.AllowedReduced}`,
      Math.round(parseFloat(site[SiteFieldEnum.MaxReduced]) * attendanceFactor)
    );
    change(
      DAILY_DEPOSIT_FORM_NAME,
      `${fieldPrefix}${SiteFieldEnum.AllowedPaid}`,
      Math.round(parseFloat(site[SiteFieldEnum.MaxPaid]) * attendanceFactor)
    );
    change(
      DAILY_DEPOSIT_FORM_NAME,
      `${fieldPrefix}${SiteFieldEnum.Attendance}`,
      attendance
    );
    change(
      DAILY_DEPOSIT_FORM_NAME,
      `${fieldPrefix}${SiteFieldEnum.AttendanceFactor}`,
      formatDecimal(2)(attendanceFactor * 100)
    );
  };

  submitCheckData = () => {
    const { filterValues, getCheckData } = this.props;

    getCheckData(
      filterValues[Fields.Site],
      filterValues[Fields.Date],
      filterValues[Fields.IsSupper]
    );
  };

  render() {
    const {
      formValues,
      change,
      data,
      primarySites,
      mealSummaries,
      checks,
      loading,
      denominations,
      isDirty,
      filterValues,
    } = this.props;
    const disabled = this.shouldDisableEditing();
    return (
      <Fragment>
        {loading && <LoadingPage />}
        <Filter title={'Daily Deposit'} />
        <Main {...this.getMainProps()}>
          <DirtyWrapper>
            {showDirtyConfirm => {
              return (
                <TitledCard title={'Deposit Information'}>
                  <DailyDepositFilters
                    isFormDirty={isDirty}
                    showDirtyConfirm={showDirtyConfirm}
                    loading={loading}
                    initialValues={{
                      [Fields.Date]:
                        filterValues && filterValues[Fields.Date]
                          ? filterValues[Fields.Date]
                          : defaultDateFormat(moment()),
                      [Fields.IsSupper]:
                        filterValues && filterValues[Fields.IsSupper]
                          ? true
                          : false,
                      [Fields.Site]:
                        filterValues && filterValues[Fields.Site]
                          ? filterValues[Fields.Site]
                          : '',
                    }}
                  />
                  <DailyDepositForm
                    onSubmit={this.handleSubmit(SubmitActionEnum.CloseDay)}
                    initialValues={{
                      ...data,
                    }}
                    formValues={formValues}
                    change={change}
                    data={data}
                    primarySites={primarySites}
                    mealSummaries={mealSummaries}
                    onAttendanceBlur={this.onAttendanceBlur}
                    shouldDisableEditing={disabled}
                    confirmWarnings={this.confirmWarnings}
                    closeWarnings={this.closeWarnings}
                    onGetChecksClick={this.submitCheckData}
                    loading={loading}
                    checks={checks}
                    denominations={denominations}
                    {...this.state}
                  />
                </TitledCard>
              );
            }}
          </DirtyWrapper>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const isDirty = DailyDepositSelectors.isDirtySelector(state);
  ownProps.setPageLevelDirty(isDirty);

  return {
    isDirty,
    filterValues: DailyDepositSelectors.getDailyDepositFilterValues(state),
    formValues: DailyDepositSelectors.getDailyDepositFormValues(state),
    loading: DailyDepositSelectors.getFetching(state),
    fetchError: DailyDepositSelectors.getFetchError(state),
    data: DailyDepositSelectors.getData(state),
    primarySites: DailyDepositSelectors.getPrimarySites(state),
    mealSummaries: DailyDepositSelectors.getMealSummaries(state),
    warnings: DailyDepositSelectors.getWarnings(state),
    CEPErrors: DailyDepositSelectors.getCEPErrors(state),
    report: DailyDepositSelectors.getReport(state),
    checks: DailyDepositSelectors.getChecks(state),
    denominations: DailyDepositSelectors.getDenominations(state),
    saveSuccessful: DailyDepositSelectors.getSaveSuccessful(state),
    closeSuccessful: DailyDepositSelectors.getCloseSuccessful(state),
  };
};

const mapDispatchToProps = {
  change,
  getPrimarySites: DailyDepositActions.getPrimarySites,
  getDailyDepositData: DailyDepositActions.getDailyDepositData,
  clearError: DailyDepositActions.clearError,
  getWarnings: DailyDepositActions.getWarnings,
  clearWarnings: DailyDepositActions.clearWarnings,
  getDailyDepositReport: DailyDepositActions.getDailyDepositReport,
  getBankDepositReport: DailyDepositActions.getBankDepositReport,
  clearReport: DailyDepositActions.clearReport,
  writeCloseDay: DailyDepositActions.writeCloseDay,
  getCheckData: DailyDepositActions.getCheckData,
  writeSave: DailyDepositActions.writeSave,
  setCloseSuccessful: DailyDepositActions.setCloseSuccessful,
  setSaveSuccessful: DailyDepositActions.setSaveSuccessful,
};

export const DailyDeposit = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DailyDepositContainer)
);



// WEBPACK FOOTER //
// ./src/pages/dailydeposit/DailyDeposit.js